// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3nwn4","additionalInfo":"AgreementModal_additionalInfo__2CIFI"};